import { inject, Signal } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { ConfirmLeaveDialogComponent } from '@cumlaude/shared-components-dialogs';
import { firstValueFrom } from 'rxjs';
import { CanDeactivateFn } from '@angular/router';

export interface SaveableBeheerDashboard {
	dirty: Signal<boolean>;
}

export const saveGuard: CanDeactivateFn<any> = async (dashboard: SaveableBeheerDashboard) => {
	if (!dashboard.dirty()) return true;

	const dialog = inject(Dialog);
	const confirm = await firstValueFrom(dialog.open(ConfirmLeaveDialogComponent).closed);
	return !!confirm;
};
